<div #detailContainer class="detail-main-container">
  <div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
  </div>
    <form #detailForm="ngForm" novalidate>
      <ng-container *ngIf="detailForm">
        <div class="group-container">
          
          <!-- <div *ngIf="actions.length > 0">
            <ng-container *ngFor="let action of actions; let i=index">
              <div *ngIf="!action.DisplayOnGroup && !action.IsHidden" class="btn-primary mr-1 button-action {{i}}" (click)="formAction(action, detailForm, true)">{{ action.ActionDisplay }}</div>
            </ng-container>
          </div> -->
          <div *ngIf="currentScore" class="current-score" [innerHTML]="currentScore">
            <!-- <span style="font-size: 13px;">Current score : <span style="font-weight: bold;font-size: 14px;margin-left: 5px;">{{currentScore}} / {{maxScore}}</span></span> -->
          </div>
          <div *ngFor="let group of groups; let g=index">
            <div style="display:flex"><p class="group-header-title" style="flex: 1 1 auto;">{{group.GroupDisplay}}</p></div>
            <div *ngFor="let property of formProperties; let h=index">

              <div *ngIf="property.PropertyGroupId == group.GroupId">

                <!-- input  -->
                <div *ngIf="property.PropertyType.toUpperCase() == 'TEXT'" class="question-container" id="field_{{property.PropertyFormattedName}}">
                  <fieldset class="question-fieldset">
                    <div class="question-header-field">
                      <p class="question-header">
                        {{property.PropertyOrder}}. <span *ngIf="property.IsMandatory" class="asterisk">*</span>
                        {{property.PropertyDisplay}}
                      </p>
                      <div class="question-sub-header">
                        <app-dynamic-property [setHTML]="property.PropertySubDisplay"></app-dynamic-property>
                      </div>
                    </div>
                    <div class="question-body">
                      <!-- <div class="floating-label">
                        <input #textbox type="text" [name]="property.PropertyName" autocomplete="off" class="floating-input" 
                        placeholder=" " [value]="property.PropertyValue"
                        (change)="updatePropertyValue(property, textbox.value)"
                        [disabled]="!property.IsEditable"
                        [(ngModel)]="property.PropertyValue"
                        #PropertyValue="ngModel"
                        [ngModelOptions]="{ updateOn: 'blur'}"
                        [required]="property.IsMandatory ? property.IsMandatory : null">

                        
                        <label>Enter your response here</label>
                      </div> -->
                      <mat-form-field style="width: 99%;font-size: 13px;" class="detail-form-field">
                        <mat-label>Enter your response here</mat-label>
                        <textarea #textarea class="form-textarea"
                          [id]="property.PropertyName"
                          [name]="property.PropertyName" autocomplete="off"
                          (change)="updatePropertyValue(property, textarea.value)"
                          [disabled]="!property.IsEditable"
                          [(ngModel)]="property.PropertyValue"
                          [value]="property.PropertyValue"
                          #PropertyValue="ngModel"
                          [ngModelOptions]="{ updateOn: 'blur'}"
                          [required]="property.IsMandatory ? property.IsMandatory : null"
                          matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="5"></textarea>
                      </mat-form-field>
                    </div>
                  </fieldset>
                </div>

                <!-- single select  -->
                <div *ngIf="property.PropertyType.toUpperCase() == 'SINGLESELECT'" class="question-container" id="field_{{property.PropertyFormattedName}}">
                  <fieldset class="question-fieldset" [class.active]="invalidProperties.indexOf(property.PropertyName) > -1">
                    <div class="question-header-field">
                      <p class="question-header">
                        {{property.PropertyOrder}}. <span *ngIf="property.IsMandatory" class="asterisk">*</span>
                        {{property.PropertyDisplay}}
                      </p>
                      <div class="question-sub-header">
                        <app-dynamic-property [setHTML]="property.PropertySubDisplay"></app-dynamic-property>
                      </div>
                    </div>
                    <div class="question-body">
                      <mat-radio-group [id]="property.PropertyName" [required]="property.IsMandatory ? property.IsMandatory : null" 
                      [(ngModel)]="property.PropertyValue"
                      #PropertyValue="ngModel"
                      [name]="property.PropertyName">
                      <ng-container *ngFor="let option of property.PropertyOptions;let i=index">
                        <mat-radio-button matRadioButton #matRadio="matRadioButton"
                        class="form-radio-button"
                        id="{{property.PropertyName}}{{i}}"
                        (change)="updatePropertyValue(property, option.OptionValue)"
                        [value]="option.OptionValue"
                        [name]="property.PropertyName"
                        [checked]="option.OptionValue == property.PropertyValue"
                        [disabled]="!property.IsEditable"
                        [required]="property.IsMandatory ? property.IsMandatory : null">{{option.OptionDisplay}}
                        </mat-radio-button>
                        <div *ngIf="option.OptionRequiresRemarks && (option.OptionValue == property.PropertyValue)" class="floating-label remarks remarks_{{property.PropertyFormattedName}}" style="width: 60%;">
                          <input #remarks type="text" autocomplete="off" class="floating-input full remarks-field" [class.error]="PropertyRemark.invalid && submitted" 
                          [placeholder]="(!property.IsEditable && !property.PropertyRemarks) ? '': 'Remarks'"
                          [value]="property.PropertyRemarks"
                          [disabled]="!property.IsEditable"
                          [name]="property.PropertyName + '_remarks'"
                          (change)="updatePropertyRemarks(property, remarks.value)"
                          [(ngModel)]="property.PropertyRemarks"
                          #PropertyRemark="ngModel"
                          [required]="option.OptionRemarksMandatory ? option.OptionRemarksMandatory : null">
                          <ng-container *ngIf="PropertyRemark">
                            <div *ngIf="PropertyRemark.invalid" class="invalid-feedback" [ngStyle]="{'display': submitted && !property.PropertyRemarks ? 'block' : 'none'}">
                              <div *ngIf="PropertyRemark.errors.required">Remarks is required</div>
                            </div>
                          </ng-container>
                        </div>
                        
                      </ng-container>
                      </mat-radio-group>
                      <ng-container *ngIf="PropertyValue">
                        <div *ngIf="PropertyValue.invalid" class="invalid-feedback" [ngStyle]="{'display': submitted && !property.PropertyValue ? 'block' : 'none'}">
                          <div *ngIf="PropertyValue.errors.required">This question requires an answer.</div>
                        </div>
                      </ng-container>
                      <div *ngIf="property.HasBaseRemarks" style="margin-top: 10px;">
                        <input #baseRemarks type="text" autocomplete="off" class="floating-input full remarks-field" 
                          [placeholder]="(!property.IsEditable && !property.BaseRemarks) ? '': 'Remarks'"
                          [value]="property.BaseRemarks"
                          [disabled]="!property.IsEditable"
                          [name]="property.PropertyName + '_baseRemarks'"
                          (change)="updatePropertyBaseRemarks(property, baseRemarks.value)"
                          [(ngModel)]="property.BaseRemarks"
                          #PropertyRemark="ngModel">
                      </div>
                    </div>
                  </fieldset>
                </div>

                <!-- multiple select  -->
                <div *ngIf="property.PropertyType.toUpperCase() == 'MULTISELECT'" class="question-container" id="field_{{property.PropertyFormattedName}}">
                  <fieldset class="question-fieldset" [class.active]="invalidProperties.indexOf(property.PropertyName) > -1">
                    <div class="question-header-field">
                      <p class="question-header">
                        {{property.PropertyOrder}}. <span *ngIf="property.IsMandatory" class="asterisk">*</span>
                        {{property.PropertyDisplay}}
                      </p>
                      <div class="question-sub-header">
                        <app-dynamic-property [setHTML]="property.PropertySubDisplay"></app-dynamic-property>
                      </div>
                    </div>
                    <div class="question-body">
                      <mat-radio-group [id]="property.PropertyName" 
                        [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null" 
                        [(ngModel)]="property.PropertyValue"
                        #PropertyValue="ngModel"
                        [name]="property.PropertyName"> 
                        <div *ngFor="let option of property.PropertyOptions; let i=index" class="mat-checkbox-container">
                          <mat-checkbox matCheckbox #matCheckbox="matCheckbox"
                          class="form-checkbox"
                          (change)="updatePropertyValue(property, $event)"
                          [attr.name]="property.PropertyName"
                          [value]="option.OptionValue"
                          [disabled]="!property.IsEditable"
                          [name]="property.PropertyName"
                          [(ngModel)]="property.PropertyValue"
                          #PropertyValue="ngModel"
                          [required]="property.IsMandatory ? property.IsMandatory : null">{{option.OptionDisplay}}</mat-checkbox>
                        </div>
                      </mat-radio-group>
                      <ng-container *ngIf="PropertyValue">
                        <div *ngIf="PropertyValue.invalid" class="invalid-feedback" [ngStyle]="{'display': submitted && !property.PropertyValue ? 'block' : 'none'}">
                          <div *ngIf="PropertyValue.errors.required">This question requires an answer.</div>
                        </div>
                      </ng-container>
                    </div>
                  </fieldset>
                </div>

                <!-- matrix -->
                <div *ngIf="property.PropertyType.toUpperCase() == 'MATRIX'" class="question-container" id="field_{{property.PropertyFormattedName}}">
                  <fieldset class="question-fieldset">
                    <div class="question-header-field">
                      <p class="question-header">
                        {{property.PropertyOrder}}. <span *ngIf="property.IsMandatory" class="asterisk">*</span>
                        {{property.PropertyDisplay}}
                      </p>
                      <div class="question-sub-header">
                        <app-dynamic-property [setHTML]="property.PropertySubDisplay"></app-dynamic-property>
                      </div>
                    </div>
                    <table class="matrix-table">
                      <thead>
                        <tr>
                          <th style="width: 20%;">&nbsp;</th>
                          <th *ngFor="let group of property.PropertyOptionGroups" class="matrix-cell">{{group.GroupDisplay}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of property.PropertyOptionRows; let y = index" [id]="row[0] ? row[0].OptionValue : property.PropertyName">
                          <ng-container *ngFor="let option of row; let z=index; let first=first">
                            <td *ngIf="first"><span style="font-size: 13px">{{option.OptionDisplay}}</span></td>
                            <td class="matrix-cell">
                              <mat-radio-button matRadioButton #matRadio="matRadioButton"
                              (change)="updatePropertyValue(property, $event, z)"
                              class="matrix-radio-button"
                              id="{{option.OptionValue}}_{{z}}"
                              [disabled]="!property.IsEditable"
                              [value]="option.OptionValue"
                              [checked]="option.OptionIsSelected"
                              [name]="property.PropertyName + y">
                              </mat-radio-button>
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </div>
              </div>

            </div>
          </div>
          <div *ngIf="updatedDate" style="font-size: 14px; color: #888;padding-bottom: 20px;">Last updated date : {{updatedDate | date:'dd MMM yyyy HH:mm:ss'}}</div>
        </div>
        <!-- <div class="clearfix"></div> -->
      </ng-container>
    </form>
</div>